import api from "./api";

/**
 * Language discovery. The list is the Amazon Translate language set the
 * backend serves; it is public so the login page can use it too.
 */
const i18nService = {
  /** [{ code, name, native_name, rtl }] */
  getLanguages: async () => {
    const response = await api.get("/api/v1/i18n/languages");
    return response.data;
  },

  /** { locale, rtl, source, user_locale, team_locale, organization_locale } */
  getMyLocale: async () => {
    const response = await api.get("/api/v1/i18n/locale");
    return response.data;
  },

  /** Superuser only: identity of the deployed AWS key + a test translation. */
  translationCheck: async () => {
    const response = await api.get("/api/v1/i18n/translation-check");
    return response.data;
  },
};

export default i18nService;
